import { useEffect, useRef } from 'react';

export const useUsetifulElementObserver = (elementToObserve: string, callback: (elObserved?: HTMLElement) => void) => {
    const observerRef = useRef<MutationObserver | null>(null);

    const adjustTargetElementPosition = () => {
        const elObserved = document.querySelector(elementToObserve) as HTMLElement;

        callback(elObserved);
    };

    useEffect(() => {
        // Create a MutationObserver to watch for changes in the banner element
        const elObserved = document.querySelector(elementToObserve) as HTMLElement;

        if (elObserved) {
            observerRef.current = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        // Use setTimeout to ensure DOM is fully updated
                        setTimeout(() => callback(elObserved), 0);
                    }
                });
            });

            // Start observing changes to the banner element
            observerRef.current.observe(elObserved, {
                childList: true,
                subtree: true
            });

            // Also observe for resize changes
            const resizeObserver = new ResizeObserver(() => {
                callback(elObserved);
            });
            resizeObserver.observe(elObserved);

            // Store resize observer for cleanup
            (observerRef.current as any).resizeObserver = resizeObserver;
        }

        // Initial adjustment in case banner already has content
        callback(elObserved);

        // Cleanup function
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
                if ((observerRef.current as any).resizeObserver) {
                    (observerRef.current as any).resizeObserver.disconnect();
                }
            }
        };
    }, [elementToObserve]);

    return adjustTargetElementPosition;
};
